// Site header: the announcement banner and the navigation bar.
// Converted from the Webflow "navigation-global" symbol.

import { SlideIn } from '@components/interactions';
import {
  DismissTrigger,
  Dismissible,
  Dropdown,
  DropdownList,
  DropdownToggle,
  GithubStars,
  NavButton,
  NavLink,
  NavMenu,
  Navbar,
} from '@components/webflow';

export function SiteHeader({ banner }: { banner: boolean }) {
  return (
    <div className="navigation-global">
      {banner && (
        <Dismissible className="banner10_component" as="section" mode="hide">
          <SlideIn className="padding-global" as="div">
            <div className="banner10_content-wrapper">
              <div className="banner10_content">
                <a href="/videos" className="button is-banner w-inline-block">
                  <div className="icon-embed-xsmall w-embed">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M12.4333 15.4167C11.8664 15.4167 11.3885 15.221 10.9996 14.8296C10.6107 14.4381 10.4162 13.9589 10.4162 13.3921C10.4162 12.8252 10.6119 12.3472 11.0033 11.9584C11.3949 11.5695 11.874 11.375 12.4408 11.375C13.0078 11.375 13.4857 11.5707 13.8746 11.9621C14.2635 12.3536 14.4579 12.8328 14.4579 13.3996C14.4579 13.9666 14.2622 14.4445 13.8708 14.8334C13.4793 15.2222 13.0001 15.4167 12.4333 15.4167ZM3.79437 18.4579C3.41104 18.4579 3.07868 18.3172 2.79729 18.0357C2.51576 17.7543 2.375 17.4219 2.375 17.0386V4.21148C2.375 3.82676 2.51576 3.49322 2.79729 3.21086C3.07868 2.92836 3.41104 2.78711 3.79437 2.78711H5.10375V2.24857C5.10375 2.04926 5.17292 1.88086 5.31125 1.74336C5.44972 1.60586 5.61806 1.53711 5.81625 1.53711C6.02028 1.53711 6.19236 1.60586 6.3325 1.74336C6.47264 1.88086 6.54271 2.04926 6.54271 2.24857V2.78711H13.4565V2.24857C13.4565 2.04926 13.5257 1.88086 13.6642 1.74336C13.8025 1.60586 13.9708 1.53711 14.169 1.53711C14.3731 1.53711 14.5452 1.60586 14.6852 1.74336C14.8253 1.88086 14.8954 2.04926 14.8954 2.24857V2.78711H16.2048C16.5895 2.78711 16.9231 2.92836 17.2054 3.21086C17.4879 3.49322 17.6292 3.82676 17.6292 4.21148V17.0386C17.6292 17.4219 17.4879 17.7543 17.2054 18.0357C16.9231 18.3172 16.5895 18.4579 16.2048 18.4579H3.79437ZM3.79437 17.0386H16.2048V8.12503H3.79437V17.0386ZM3.79437 6.87503H16.2048V4.21148H3.79437V6.87503Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                  <div className="button_banner-text">{'Watch Oct 22 DBOS User Group Recordings: Cortex & Credix'}</div>
                </a>
              </div>
              <DismissTrigger href="#" className="banner10_close-button w-inline-block" as="a">
                <div className="icon-embed-small w-embed">
                  <svg width="100%" height="100%" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M22.8354 22.864L22.3639 23.3354C22.1036 23.5957 21.6815 23.5957 21.4211 23.3354L16 17.9142L10.5788 23.3353C10.3185 23.5957 9.89638 23.5957 9.63603 23.3353L9.16462 22.8639C8.90427 22.6036 8.90427 22.1815 9.16462 21.9211L14.5858 16.5L9.16462 11.0788C8.90427 10.8185 8.90427 10.3964 9.16462 10.136L9.63602 9.66463C9.89637 9.40428 10.3185 9.40428 10.5788 9.66463L16 15.0858L21.4211 9.66462C21.6815 9.40427 22.1036 9.40427 22.3639 9.66462L22.8354 10.136C23.0957 10.3964 23.0957 10.8185 22.8354 11.0788L17.4142 16.5L22.8354 21.9211C23.0957 22.1815 23.0957 22.6036 22.8354 22.864Z"
                      fill="currentColor"
                    />
                    {'\n'}
                  </svg>
                </div>
              </DismissTrigger>
            </div>
          </SlideIn>
        </Dismissible>
      )}
      <Navbar
        data-animation="default"
        className="navbar5_component w-nav"
        data-easing2="ease"
        fs-scrolldisable-element="smart-nav"
        data-easing="ease"
        data-collapse="medium"
        role="banner"
        data-duration="400"
      >
        <div className="navbar5_container">
          <NavLink href="/" className="navbar5_logo-link w-nav-brand">
            <img
              width="108"
              src="/assets/images/67241465129b580e4b924af4_Vectors-Wrapper.svg"
              alt="DBOS - Logo"
              className="navigation-logo-new"
            />
          </NavLink>
          <NavMenu role="navigation" className="navbar5_menu w-nav-menu">
            <div className="navbar5_menu-left">
              <Dropdown data-delay="200" data-hover="true" className="navbar-dropdown_component w-dropdown">
                <DropdownToggle className="navbar-dropdown8_dropdown-toggle w-dropdown-toggle">
                  <div>Products</div>
                  <div className="dropdown-chevron w-embed">
                    <svg
                      width=" 100%"
                      height=" 100%"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {'\n'}
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.55806 6.29544C2.46043 6.19781 2.46043 6.03952 2.55806 5.94189L3.44195 5.058C3.53958 4.96037 3.69787 4.96037 3.7955 5.058L8.00001 9.26251L12.2045 5.058C12.3021 4.96037 12.4604 4.96037 12.5581 5.058L13.4419 5.94189C13.5396 6.03952 13.5396 6.19781 13.4419 6.29544L8.17678 11.5606C8.07915 11.6582 7.92086 11.6582 7.82323 11.5606L2.55806 6.29544Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </DropdownToggle>
                <DropdownList className="navbar-dropdown8_dropdown-list w-dropdown-list">
                  <div className="navbar-dropdown8_dropdown-link-list">
                    <NavLink href="/dbos-transact" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M9.39584 16.5625L13.4583 8.56246H10.6667V3.43746L6.60417 11.3958H9.39584V16.5625ZM10 18.3333C8.84723 18.3333 7.76389 18.1145 6.75001 17.677C5.73612 17.2395 4.85417 16.6458 4.10417 15.8958C3.35417 15.1458 2.76042 14.2638 2.32292 13.25C1.88542 12.2361 1.66667 11.1527 1.66667 9.99996C1.66667 8.84718 1.88542 7.76385 2.32292 6.74996C2.76042 5.73607 3.35417 4.85413 4.10417 4.10413C4.85417 3.35413 5.73612 2.76038 6.75001 2.32288C7.76389 1.88538 8.84723 1.66663 10 1.66663C11.1528 1.66663 12.2361 1.88538 13.25 2.32288C14.2639 2.76038 15.1458 3.35413 15.8958 4.10413C16.6458 4.85413 17.2396 5.73607 17.6771 6.74996C18.1146 7.76385 18.3333 8.84718 18.3333 9.99996C18.3333 11.1527 18.1146 12.2361 17.6771 13.25C17.2396 14.2638 16.6458 15.1458 15.8958 15.8958C15.1458 16.6458 14.2639 17.2395 13.25 17.677C12.2361 18.1145 11.1528 18.3333 10 18.3333ZM14.6563 14.6612C15.941 13.3798 16.5833 11.8277 16.5833 10.005C16.5833 8.18218 15.9426 6.62843 14.6613 5.34371C13.3799 4.05899 11.8278 3.41663 10.005 3.41663C8.18223 3.41663 6.62848 4.05732 5.34376 5.33871C4.05903 6.6201 3.41667 8.17218 3.41667 9.99496C3.41667 11.8177 4.05737 13.3715 5.33876 14.6562C6.62014 15.9409 8.17223 16.5833 9.99501 16.5833C11.8178 16.5833 13.3715 15.9426 14.6563 14.6612Z"
                              fill="url(#paint0_linear_9075_5431)"
                            />
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_9075_5431"
                              x1="5"
                              y1="1.66663"
                              x2="18.0078"
                              y2="1.66663"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">DBOS Transact</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          Open source durable execution library
                        </p>
                      </div>
                    </NavLink>
                    <NavLink href="/dbos-conductor" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M7.71429 12.2857V7.71429H12.2857V12.2857H7.71429ZM9.42857 10.5714H10.5714V9.42857H9.42857V10.5714ZM7.14286 18V15.7143H6C5.53968 15.7143 5.13889 15.5437 4.79762 15.2024C4.45635 14.8611 4.28571 14.4603 4.28571 14V12.8571H2V11.1429H4.28571V8.85714H2V7.14286H4.28571V6C4.28571 5.53968 4.45635 5.13889 4.79762 4.79762C5.13889 4.45635 5.53968 4.28571 6 4.28571H7.14286V2H8.85714V4.28571H11.1429V2H12.8571V4.28571H14C14.4603 4.28571 14.8611 4.45635 15.2024 4.79762C15.5437 5.13889 15.7143 5.53968 15.7143 6V7.14286H18V8.85714H15.7143V11.1429H18V12.8571H15.7143V14C15.7143 14.4603 15.5437 14.8611 15.2024 15.2024C14.8611 15.5437 14.4603 15.7143 14 15.7143H12.8571V18H11.1429V15.7143H8.85714V18H7.14286ZM14 14V6H6V14H14Z"
                              fill="url(#paint0_linear_9075_5437)"
                            />
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_9075_5437"
                              x1="4.5"
                              y1="2"
                              x2="17.6875"
                              y2="2"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">DBOS Conductor</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          {'Control plane for agents & workflows'}
                        </p>
                      </div>
                    </NavLink>
                  </div>
                </DropdownList>
              </Dropdown>
              <NavLink href="/dbos-pricing" className="navbar5_link w-nav-link">
                Pricing
              </NavLink>
              <NavLink href="/customer-stories" className="navbar5_link w-nav-link">
                Customers
              </NavLink>
              <Dropdown data-delay="200" data-hover="true" className="navbar-dropdown_component w-dropdown">
                <DropdownToggle className="navbar-dropdown8_dropdown-toggle w-dropdown-toggle">
                  <div>Resources</div>
                  <div className="dropdown-chevron w-embed">
                    <svg
                      width=" 100%"
                      height=" 100%"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {'\n'}
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.55806 6.29544C2.46043 6.19781 2.46043 6.03952 2.55806 5.94189L3.44195 5.058C3.53958 4.96037 3.69787 4.96037 3.7955 5.058L8.00001 9.26251L12.2045 5.058C12.3021 4.96037 12.4604 4.96037 12.5581 5.058L13.4419 5.94189C13.5396 6.03952 13.5396 6.19781 13.4419 6.29544L8.17678 11.5606C8.07915 11.6582 7.92086 11.6582 7.82323 11.5606L2.55806 6.29544Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </DropdownToggle>
                <DropdownList className="navbar-dropdown8_dropdown-list w-dropdown-list">
                  <div className="navbar-dropdown8_dropdown-link-list">
                    <NavLink href="/about" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M16.604 11.048C17.2131 10.0101 17.4761 8.80528 17.355 7.60797C17.176 5.82397 16.18 4.24697 14.552 3.16797L13.447 4.83397C14.566 5.57597 15.247 6.63297 15.365 7.80797C15.4194 8.35407 15.3514 8.90543 15.166 9.42195C14.9806 9.93847 14.6823 10.4072 14.293 10.794L13.101 11.986L14.719 12.461C18.951 13.701 19 17.957 19 18H21C21 16.211 20.044 12.715 16.604 11.048Z"
                              fill="currentColor"
                            />
                            {'\n'}
                            <path
                              d="M9.5 12C11.706 12 13.5 10.206 13.5 8C13.5 5.794 11.706 4 9.5 4C7.294 4 5.5 5.794 5.5 8C5.5 10.206 7.294 12 9.5 12ZM9.5 6C10.603 6 11.5 6.897 11.5 8C11.5 9.103 10.603 10 9.5 10C8.397 10 7.5 9.103 7.5 8C7.5 6.897 8.397 6 9.5 6ZM11 13H8C4.691 13 2 15.691 2 19V20H4V19C4 16.794 5.794 15 8 15H11C13.206 15 15 16.794 15 19V20H17V19C17 15.691 14.309 13 11 13Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">About DBOS</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          Meet the team simplifying reliability.
                        </p>
                      </div>
                    </NavLink>
                    <NavLink href="/videos" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M18 7C18 5.897 17.103 5 16 5H4C2.897 5 2 5.897 2 7V17C2 18.103 2.897 19 4 19H16C17.103 19 18 18.103 18 17V13.667L22 17V7L18 10.333V7ZM16.002 17H4V7H16L16.001 11.999L16 12L16.001 12.001L16.002 17Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">Videos</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Demos, deep dives, and more DBOS.</p>
                      </div>
                    </NavLink>
                    <NavLink href="/partners" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M11.4027 7.69625L9.38742 5.656C9.21759 5.486 9.13267 5.28608 9.13267 5.05625C9.13267 4.82642 9.21759 4.6265 9.38742 4.4565L11.4027 2.41625C11.5727 2.24642 11.7726 2.1615 12.0024 2.1615C12.2323 2.1615 12.4322 2.24642 12.6022 2.41625L14.6424 4.4565C14.8123 4.6265 14.8972 4.82642 14.8972 5.05625C14.8972 5.28608 14.8123 5.486 14.6424 5.656L12.6022 7.69625C12.4322 7.86608 12.2323 7.951 12.0024 7.951C11.7726 7.951 11.5727 7.86608 11.4027 7.69625ZM1.67767 20.293C1.43317 20.293 1.23009 20.2122 1.06842 20.0505C0.906922 19.889 0.826172 19.6859 0.826172 19.4412V16.1912C0.826172 15.6801 1.00792 15.2437 1.37142 14.882C1.73509 14.5205 2.17051 14.3397 2.67767 14.3397H6.23267C6.52384 14.3397 6.79367 14.4066 7.04217 14.5402C7.2905 14.6739 7.50234 14.8597 7.67767 15.0977C8.16901 15.8097 8.79567 16.3614 9.55767 16.7527C10.3195 17.1441 11.1334 17.3397 11.9994 17.3397C12.8614 17.3397 13.6743 17.1441 14.4382 16.7527C15.2022 16.3614 15.8402 15.8097 16.3522 15.0977C16.5195 14.8597 16.7242 14.6739 16.9662 14.5402C17.2083 14.4066 17.477 14.3397 17.7722 14.3397H21.3272C21.8383 14.3397 22.2748 14.5205 22.6364 14.882C22.9979 15.2437 23.1787 15.6801 23.1787 16.1912V19.4412C23.1787 19.6859 23.0979 19.889 22.9364 20.0505C22.7748 20.2122 22.5717 20.293 22.3272 20.293H17.3272C17.0825 20.293 16.8794 20.2122 16.7179 20.0505C16.5563 19.889 16.4754 19.6859 16.4754 19.4412V17.282C15.8714 17.8122 15.1849 18.2232 14.4159 18.5152C13.6469 18.8072 12.8414 18.9532 11.9994 18.9532C11.1614 18.9532 10.3611 18.8082 9.59842 18.5182C8.83575 18.2282 8.14609 17.8162 7.52942 17.282V19.4412C7.52942 19.6859 7.44859 19.889 7.28692 20.0505C7.12526 20.2122 6.92217 20.293 6.67767 20.293H1.67767ZM3.99942 12.4102C3.23742 12.4102 2.58159 12.1354 2.03192 11.5857C1.48242 11.0362 1.20767 10.3785 1.20767 9.6125C1.20767 8.83783 1.48242 8.17883 2.03192 7.6355C2.58159 7.09233 3.23742 6.82075 3.99942 6.82075C4.77809 6.82075 5.43909 7.09233 5.98242 7.6355C6.52559 8.17883 6.79717 8.83783 6.79717 9.6125C6.79717 10.3785 6.52559 11.0362 5.98242 11.5857C5.43909 12.1354 4.77809 12.4102 3.99942 12.4102ZM19.9994 12.4102C19.2374 12.4102 18.5816 12.1354 18.0319 11.5857C17.4824 11.0362 17.2077 10.3785 17.2077 9.6125C17.2077 8.83783 17.4824 8.17883 18.0319 7.6355C18.5816 7.09233 19.2374 6.82075 19.9994 6.82075C20.7781 6.82075 21.4391 7.09233 21.9824 7.6355C22.5256 8.17883 22.7972 8.83783 22.7972 9.6125C22.7972 10.3785 22.5256 11.0362 21.9824 11.5857C21.4391 12.1354 20.7781 12.4102 19.9994 12.4102Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">Partners</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Explore the DBOS ecosystem.</p>
                      </div>
                    </NavLink>
                  </div>
                </DropdownList>
              </Dropdown>
              <Dropdown data-delay="200" data-hover="true" className="navbar-dropdown_component w-dropdown">
                <DropdownToggle className="navbar-dropdown8_dropdown-toggle w-dropdown-toggle">
                  <div>Docs</div>
                  <div className="dropdown-chevron w-embed">
                    <svg
                      width=" 100%"
                      height=" 100%"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {'\n'}
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.55806 6.29544C2.46043 6.19781 2.46043 6.03952 2.55806 5.94189L3.44195 5.058C3.53958 4.96037 3.69787 4.96037 3.7955 5.058L8.00001 9.26251L12.2045 5.058C12.3021 4.96037 12.4604 4.96037 12.5581 5.058L13.4419 5.94189C13.5396 6.03952 13.5396 6.19781 13.4419 6.29544L8.17678 11.5606C8.07915 11.6582 7.92086 11.6582 7.82323 11.5606L2.55806 6.29544Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </DropdownToggle>
                <DropdownList className="navbar-dropdown8_dropdown-list w-dropdown-list">
                  <div className="navbar-dropdown8_dropdown-link-list">
                    <a
                      href="https://docs.dbos.dev/quickstart"
                      className="navbar-dropdown8_dropdown-link w-inline-block"
                    >
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M11.25 17L11.75 11.5H7.0625L13 3H13.75L13 8.5H17.8958L12 17H11.25ZM3.02083 14.5V13H10L9.77083 14.5H3.02083ZM2 10.75V9.25H6.75L5.70833 10.75H2ZM4 7V5.5H9.41667L8.35417 7H4Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">Quickstart</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          Launch your first workflow in minutes.
                        </p>
                      </div>
                    </a>
                    <a href="https://docs.dbos.dev/" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M21 3H14C13.2596 3.00251 12.5466 3.28057 12 3.78C11.4534 3.28057 10.7404 3.00251 10 3H3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H8.758C9.284 20 9.8 20.214 10.172 20.586L11.293 21.707C11.302 21.716 11.314 21.719 11.323 21.728C11.409 21.807 11.505 21.877 11.617 21.924H11.619C11.863 22.025 12.137 22.025 12.381 21.924H12.383C12.495 21.877 12.591 21.807 12.677 21.728C12.686 21.719 12.698 21.716 12.707 21.707L13.828 20.586C14.2039 20.2123 14.7119 20.0017 15.242 20H21C21.2652 20 21.5196 19.8946 21.7071 19.7071C21.8946 19.5196 22 19.2652 22 19V4C22 3.73478 21.8946 3.48043 21.7071 3.29289C21.5196 3.10536 21.2652 3 21 3ZM8.758 18H4V5H10C10.552 5 11 5.449 11 6V18.689C10.3375 18.2422 9.5571 18.0024 8.758 18ZM20 18H15.242C14.443 18 13.658 18.246 13 18.689V6C13 5.449 13.448 5 14 5H20V18Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">Docs</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          {'Step-by-step guides & real-world use cases.'}
                        </p>
                      </div>
                    </a>
                    <a href="https://docs.dbos.dev/examples" className="navbar-dropdown8_dropdown-link w-inline-block">
                      <div className="navbar-dropdown8_icon-wrapper">
                        <div className="w-embed">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M19 10V7C19 5.897 18.103 5 17 5H14C14 3.346 12.654 2 11 2C9.346 2 8 3.346 8 5H5C3.897 5 3 5.897 3 7V10.881L3.659 11.12C4.461 11.41 5 12.166 5 13C5 13.834 4.461 14.59 3.659 14.88L3 15.119V19C3 20.103 3.897 21 5 21H8.881L9.12 20.341C9.41 19.539 10.166 19 11 19C11.834 19 12.59 19.539 12.88 20.341L13.119 21H17C18.103 21 19 20.103 19 19V16C20.654 16 22 14.654 22 13C22 11.346 20.654 10 19 10ZM19 14H17L16.997 19H14.452C13.741 17.78 12.43 17 11 17C9.57 17 8.259 17.78 7.548 19H5V16.452C6.22 15.741 7 14.43 7 13C7 11.57 6.22 10.259 5 9.548V7H10V5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4C11.2652 4 11.5196 4.10536 11.7071 4.29289C11.8946 4.48043 12 4.73478 12 5V7H17V12H19C19.2652 12 19.5196 12.1054 19.7071 12.2929C19.8946 12.4804 20 12.7348 20 13C20 13.2652 19.8946 13.5196 19.7071 13.7071C19.5196 13.8946 19.2652 14 19 14Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="navbar-dropdown8_text-wrapper">
                        <div className="text-weight-medium">Example Applications</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          Ready-to-run code to spark your project.
                        </p>
                      </div>
                    </a>
                  </div>
                </DropdownList>
              </Dropdown>
              <NavLink href="/blog" className="navbar5_link w-nav-link">
                Blog
              </NavLink>
            </div>
            <div className="navbar5_menu-right">
              <div className="div-block-62">
                <a
                  href="https://discord.com/invite/jsmC6pXGgX"
                  className="footer5_social-link is-discord w-inline-block"
                >
                  <div className="icon-embed-xsmall w-embed">
                    <svg width="100%" height="100%" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      {'\n'}
                      <path
                        d="M14.2524 6.66699C14.096 6.94165 13.9556 7.22579 13.828 7.51624C12.6154 7.33629 11.3806 7.33629 10.1649 7.51624C10.0404 7.22579 9.89682 6.94165 9.74048 6.66699C8.60133 6.85958 7.49091 7.19738 6.43793 7.67409C4.3511 10.7333 3.78631 13.7136 4.06711 16.6528C5.28921 17.5462 6.6581 18.2282 8.11632 18.6638C8.44498 18.2282 8.73535 17.7641 8.98424 17.281C8.51199 17.1074 8.05569 16.8896 7.61855 16.637C7.73341 16.5549 7.8451 16.4697 7.95358 16.3876C10.5159 17.581 13.4834 17.581 16.0488 16.3876C16.1573 16.476 16.269 16.5612 16.3839 16.637C15.9467 16.8927 15.4904 17.1074 15.015 17.2842C15.2639 17.7672 15.5542 18.2313 15.8829 18.667C17.3411 18.2313 18.71 17.5525 19.9322 16.6591C20.2639 13.2495 19.3641 10.2945 17.5548 7.67725C16.5051 7.20054 15.3947 6.86273 14.2555 6.6733L14.2524 6.66699ZM9.34161 14.8438C8.55348 14.8438 7.89935 14.1366 7.89935 13.2621C7.89935 12.3876 8.52794 11.6773 9.33843 11.6773C10.1489 11.6773 10.7935 12.3908 10.7807 13.2621C10.7679 14.1335 10.1457 14.8438 9.34161 14.8438ZM14.6576 14.8438C13.8663 14.8438 13.2185 14.1366 13.2185 13.2621C13.2185 12.3876 13.8471 11.6773 14.6576 11.6773C15.4681 11.6773 16.1094 12.3908 16.0967 13.2621C16.0839 14.1335 15.4617 14.8438 14.6576 14.8438Z"
                        fill="currentColor"
                      />
                      {'\n'}
                    </svg>
                  </div>
                </a>
                <Dropdown data-delay="200" data-hover="true" className="navbar-dropdown_component w-dropdown">
                  <DropdownToggle className="navbar-dropdown8_dropdown-toggle is-github w-dropdown-toggle">
                    <div className="div-block-50">
                      <div className="text-block-7">Explore</div>
                      <div className="w-embed">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.97914 0C3.11986 0 0 3.20833 0 7.17748C0 10.3502 1.999 13.0359 4.77214 13.9864C5.11886 14.0579 5.24586 13.832 5.24586 13.642C5.24586 13.4756 5.23443 12.9052 5.23443 12.311C3.293 12.7388 2.88871 11.4554 2.88871 11.4554C2.57671 10.6235 2.11443 10.4097 2.11443 10.4097C1.479 9.97004 2.16071 9.97004 2.16071 9.97004C2.86557 10.0176 3.23543 10.7068 3.23543 10.7068C3.85929 11.8 4.86457 11.4911 5.269 11.3009C5.32671 10.8375 5.51171 10.5166 5.70814 10.3384C4.15971 10.172 2.53057 9.55412 2.53057 6.79715C2.53057 6.01285 2.80771 5.37119 3.24686 4.87215C3.17757 4.69394 2.93486 3.95704 3.31629 2.97077C3.31629 2.97077 3.90557 2.7806 5.23429 3.70752C5.80315 3.55041 6.38982 3.47049 6.97914 3.46981C7.56843 3.46981 8.16914 3.55308 8.72386 3.70752C10.0527 2.7806 10.642 2.97077 10.642 2.97077C11.0234 3.95704 10.7806 4.69394 10.7113 4.87215C11.162 5.37119 11.4277 6.01285 11.4277 6.79715C11.4277 9.55412 9.79857 10.1601 8.23857 10.3384C8.49286 10.5642 8.71229 10.9919 8.71229 11.6693C8.71229 12.6318 8.70086 13.4043 8.70086 13.6418C8.70086 13.832 8.828 14.0579 9.17457 13.9866C11.9477 13.0357 13.9467 10.3502 13.9467 7.17748C13.9581 3.20833 10.8269 0 6.97914 0Z"
                            fill="currentColor"
                          />
                          {'\n'}
                        </svg>
                      </div>
                      <GithubStars id="github-stars" />
                    </div>
                    <div className="dropdown-chevron w-embed">
                      <svg
                        width=" 100%"
                        height=" 100%"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {'\n'}
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.55806 6.29544C2.46043 6.19781 2.46043 6.03952 2.55806 5.94189L3.44195 5.058C3.53958 4.96037 3.69787 4.96037 3.7955 5.058L8.00001 9.26251L12.2045 5.058C12.3021 4.96037 12.4604 4.96037 12.5581 5.058L13.4419 5.94189C13.5396 6.03952 13.5396 6.19781 13.4419 6.29544L8.17678 11.5606C8.07915 11.6582 7.92086 11.6582 7.82323 11.5606L2.55806 6.29544Z"
                          fill="currentColor"
                        />
                        {'\n'}
                      </svg>
                    </div>
                  </DropdownToggle>
                  <DropdownList className="navbar-dropdown8_dropdown-list dropdown-list-alt w-dropdown-list">
                    <div className="navbar-dropdown8_dropdown-link-list dropdown-list-alt">
                      <a
                        href="https://github.com/dbos-inc/dbos-transact-py"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos/dbos-transact-py</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Durable Execution Library - Python</p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc/dbos-transact-ts"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos/dbos-transact-ts</div>
                        <p className="text-size-small-nav hide-mobile-landscape">
                          Durable Execution Library - TypeScript
                        </p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc/dbos-transact-go"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos-inc/dbos-transact-go</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Durable Execution Library - Go</p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc/dbos-transact-rust"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos/dbos-transact-rust</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Durable Execution Library - Rust</p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc/dbos-transact-java"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos-inc/dbos-transact-java</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Durable Execution Library - Java</p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc/dbos-demo-apps"
                        className="navbar-dropdown9_dropdown-link w-inline-block"
                      >
                        <div className="text-weight-medium">dbos-inc/dbos-demo-apps</div>
                        <p className="text-size-small-nav hide-mobile-landscape">Demo DBOS applications</p>
                      </a>
                      <a
                        href="https://github.com/dbos-inc"
                        className="navbar-dropdown9_dropdown-external w-inline-block"
                      >
                        <div className="text-weight-medium">See all repos</div>
                        <div className="w-embed">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M10.8334 2.5L13.5775 5.24417L7.74419 11.0775L8.92252 12.2558L14.7559 6.4225L17.5 9.16667V2.5H10.8334Z"
                              fill="currentColor"
                            />
                            {'\n'}
                            <path
                              d="M15.8333 15.8333H4.16667V4.16667H10L8.33333 2.5H4.16667C3.2475 2.5 2.5 3.2475 2.5 4.16667V15.8333C2.5 16.7525 3.2475 17.5 4.16667 17.5H15.8333C16.7525 17.5 17.5 16.7525 17.5 15.8333V11.6667L15.8333 10V15.8333Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </DropdownList>
                </Dropdown>
              </div>
              <a href="https://console.dbos.dev/" className="button secondary-small w-inline-block">
                <div className="text-block-4 secondary-small-3">Sign in</div>
                <div className="icon-arrow-right secondary-small-4 w-embed">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                      fill="var(--_color-scheme-july-2025---background)"
                    />
                    {'\n'}
                  </svg>
                </div>
                <div className="icon-chevron-right secondary-small-5 w-embed">
                  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                      fill="#F3F6F8"
                    />
                    {'\n'}
                  </svg>
                </div>
              </a>
              <a href="https://console.dbos.dev/" className="button primary-small-2 w-inline-block">
                <div className="text-block-9">Get started</div>
                <div className="icon-arrow-right primary-small-4 w-embed">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                      fill="var(--_color-scheme-july-2025---background)"
                    />
                    {'\n'}
                  </svg>
                </div>
                <div className="icon-chevron-right primary-small-5 w-embed">
                  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {'\n'}
                    <path
                      d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                      fill="#F3F6F8"
                    />
                    {'\n'}
                  </svg>
                </div>
              </a>
            </div>
          </NavMenu>
          <NavButton className="navbar5_menu-button w-nav-button">
            <div className="menu-icon1">
              <div className="menu-icon1_line-top" />
              <div className="menu-icon1_line-middle">
                <div className="menu-icon1_line-middle-inner" />
              </div>
              <div className="menu-icon1_line-bottom" />
            </div>
          </NavButton>
        </div>
      </Navbar>
    </div>
  );
}
